module.exports = __webpack_public_path__ + "static/media/myFlixHome.b7d29eb2.jpg";